// extracted by mini-css-extract-plugin
module.exports = {"programme":"Programme_programme__6IE12"};